export default "__VITE_ASSET__VmCu91o9__"